module.exports = __webpack_public_path__ + "static/media/49.ec488a63.jpg";